import { z } from 'zod';

// ── Request (POST payload) ──────────────────────────────
export const SignoutSchema = z.object({
  refresh_token: z.string({
    error: 'Refresh Token tidak valid!',
  }),
});

export type SignoutPayload = z.infer<typeof SignoutSchema>;

// ── Response (API shape → data is null) ─────────────────
const SignoutApiSchema = z
  .object({
    data: z.null(),
  })
  .transform(raw => raw.data);

export type SignoutDTO = z.infer<typeof SignoutApiSchema>;

export function toSignoutDTO(raw: unknown): SignoutDTO {
  return SignoutApiSchema.parse(raw);
}
